<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <div
        style="text-align:center; font-size: 20px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
      >
        {{ $route.params.id ? $t('banner.update') : $t('banner.add') }}
      </div>
    </div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group required">
            <label class="col-sm-3 control-label">{{
                $t("banner.image")
            }}</label>
            <div class="col-sm-6">
                <img
                    id="banner-img-id"
                    :src="banner.imageUrl !== null && banner.imageUrl !== '' ? banner.imageUrl : img_url.img_other_no_picture_available"
                    class="banner-img-class img-responsive"
                    alt="issuance-img">
                <div style="padding-top: 6px;">
                    <input
                        id="upload-banner-img"
                        type="file"
                        accept="image/*"
                        @change="onSelectBannerImg">
                    <p>{{ $t('banner.clickImageToAddOrUpdate') }}</p>
                    <span
                        v-if="banner.imageUrl !== null && banner.imageUrl !== ''"
                        class="remove-banner-img"
                        @click="onClickRemoveBannerImg">{{ $t('common.delete') }}</span>
                </div>
            </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t('banner.title')
          }}</label>
          <div class="col-sm-6">
            <input
                v-model="banner.title"
              type="text"
              class="form-control"
              :placeholder="$t('banner.title')"
            />
          </div>
        </div>
        <div class="form-group required">
          <label class="col-sm-3 control-label">{{
            $t('banner.position')
          }}</label>
          <div class="col-sm-6">
            <select
              v-model="positionSelected"
              class="form-control"
              style="width: 100%;"
              >
              <option
                  v-for="position in positionList"
                  v-bind:key="position.id"
                  class="form-control"
                  v-bind:value="position.id"
              >{{ $t(position.name) }}</option>
              </select>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-danger"
          style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          @click="onBack"
        >
          <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
          {{ $t("common.back") }}
        </button>

        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onCreateBanner"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </form>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import configuration from "../../lib/config";
import axios from "axios";
// import utils from '@/lib/utils'

export default {
  name: "BannerAdd",
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      isLoading: false,
      banner: {
        imageUrl: '',
        imageFile: '',
        title: null
      },
      token: null,
      media_dns: null,
      positionSelected: null,
      positionList: [
        {
          id: null,
          name: 'banner.selectPosition'
        },
        {
          id: 1,
          name: 'banner.top'
        },
        {
          id: 2,
          name: 'banner.bottom'
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  watch: {
  },
  created () {
      this.GET_TOKEN_UPLOAD()
      .then(
        function(res) {
          this.token = res.token;
          this.media_dns = res.domain;
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    let bannerId = this.$route.params.id
    if (bannerId) {
      this.GET_BANNER_DETAIL({id: bannerId}).then(
        function (res) {
          let data = res.data
          this.banner.title = data.title
          this.banner.imageUrl = data.image_url
          this.positionSelected = data.position
        }.bind(this)
      )
    }
  },
  mounted() {
    $(function () {
      $('#banner-img-id').on('click', function () {
        $('#upload-banner-img').click()
      })
    })
  },
  methods: {
    /**
     * Set default
     */
    setDefault: function () {
        this.banner.title = null
        this.banner.imageUrl = null
        this.banner.imageFile = null
        this.positionSelected = null
    },
    /**
     * Create banner
     */
    onCreateBanner: async function () {
        let filter = {
          title: this.banner.title,
          imageUrl: this.banner.imageUrl,
          position: this.positionSelected
        }
        if (this.banner.imageFile) {
          await this.uploadBannerImage()
          filter['imageUrl'] = this.banner.imageUrl
        }
        let bannerId = this.$route.params.id
        if (bannerId) {
          this.UPDATE_BANNER({id: bannerId, ...filter}).then(
            function () {
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        } else {
          this.CREATE_BANNER(filter).then(
            function () {
              this.setDefault()
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function () {
              this.ERROR_TOAST()
            }.bind(this)
          )
        }
    },
    /**
     * Upload advertisement image
     */
    uploadBannerImage: async function () {
      let formData = new FormData()
      formData.append('file', this.banner.imageFile)
      formData.append('directory', 'apartment/banner')
      formData.append('forceOverride', true)
      await axios({
        method: 'POST',
        timeout: 6000,
        url: this.media_dns + '/api/v1/upload/',
        data: formData,
        headers: { Authorization: `JWT ${this.token}` }
      }).then(
        async function (res) {
          let data = res.data
          this.banner.imageUrl = data.domain + data.url
        }.bind(this)
      ).catch(
        async function () {
          this.banner.imageUrl = null
        }.bind(this)
      )
    },
    /**
     * Back
     */
    onBack: function () {
        window.history.back()
    },
    /**
     * Remove issuance img
     */
    onClickRemoveBannerImg: function () {
      let inputForm = $('#upload-banner-img')
      inputForm.val('')
      this.banner.imageUrl = null
      this.banner.imageFile = null
    },
    /**
     * Select issuance img
     */
    onSelectBannerImg: function (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.getResultFile(files[0])
      this.banner.imageUrl = URL.createObjectURL(files[0])
    },
    getResultFile: function (file) {
      let vm = this
      vm.banner.imageFile = file
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_TOKEN_UPLOAD",
      "CREATE_BANNER",
      "GET_BANNER_DETAIL",
      "UPDATE_BANNER"
    ]),
  },
  components: {
    Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
.banner-img-class{
  width: 80%;
  cursor: pointer;
}
input[type="file"] {
  display: none;
}
.remove-banner-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-banner-img:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/Banner/BannerAdd.vue